const tr = {
  corporationPaymentServices:{
    attributes:{
      id:                   'Id',
      services:             'Serviços',
      service:              'Serviço',
      is_fixed:             'Possui pacote fixo?',
      fixed_amount:         'Quantidade fixa',
      excess_price:         'Preço por excedente (R$)',
      price:                'Preço (R$)',
      payment_service:      'Serviço',
      payment_wallet:       'Carteira',
      created_at:           'Criado em',
      updated_at:           'Atualizado em',
      payment_service_id:   'Serviço',
      payment_wallet_id:    'Carteira',
      payment_method_id:    'Tipo',
      corporation_id:       'Empresa',
      count:                'Quantidade',
      total_price:          'Preço total (R$)',
      competency_data:      'Data de competência',
      unitary_price:        'Preço unitário (R$)',
      is_include_corporation_branches: 'Considerar empresas filiais',
    },
    extras:{
      services:             'Serviços',
    },
    dialog: {

    },
    defSingular: 'Empresa',
    defPlural: 'Empresas',
  }
};

export default tr;
